import React, { FC, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

import { Container, ListWrapper, ListItem } from './styles';

const routes = ['Portal IE', 'Configurações'];
const lastIndex = routes.length - 1;
interface BreadcumbProps {
  routes?: string[];
}
const Breadcumb: FC = () => {
  return (
    <Container>
      <ListWrapper>
        {routes.map((item, index) => {
          if (lastIndex === index) {
            return (
              <ListItem key={item} isActive>
                {item}
              </ListItem>
            );
          }

          return (
            <Fragment key={item}>
              <ListItem>{item}</ListItem>
              <FontAwesomeIcon icon={faAngleRight} size="1x" />
            </Fragment>
          );
        })}
      </ListWrapper>
    </Container>
  );
};

export default Breadcumb;
